'use strict';

var $ = window.jQuery;
var Cycle = require('../lib/third-party/jquery.cycle.js');

function init() {
	$('.slideshow__slides').cycle({
		speed : 750,
		autoHeight : -1,
		delay : 3000,
		timeout : 6500,
		fx : 'scrollHorz',
		slides : '.slideshow__slide',
		log: false
	});
}

module.exports = {
	init: init
};
